import { useAnalyticSession } from "@octopusdeploy/portal-analytics";
import type { ArgoCDProjectSelectionFields } from "~/analytics/AnalyticSession";
import type { ArgoCDProjectSelectionDispatcher, ArgoCDProjectSelectionEvent } from "~/analytics/Analytics";
export function useArgoCDProjectSelectionDispatcher(): ArgoCDProjectSelectionDispatcher {
    const session = useAnalyticSession();
    return (name: string, event: ArgoCDProjectSelectionEvent) => {
        const fields: ArgoCDProjectSelectionFields = {
            "Gateway Name": session.anonymize(`${event.gatewayName}`),
            "Space Id": session.anonymize(`${event.spaceId}`),
            "Unique Identifier": session.anonymize(`${event.spaceId}-${event.gatewayName}`),
        };
        if (event.selectionType) {
            fields["Selection Type"] = event.selectionType;
        }
        session.track(name, fields);
    };
}
